import React, { useEffect, useState } from 'react';
import { Box } from 'native-base';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel, Pagination, Keyboard } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { Stashboard, StashboardMedia } from '@springbig/shared';

import { Caption } from './Typography';
import { useMessagesStyles } from './styles';
import { CarouselCard } from '~/pages/message/components/MessageCarouselCard';

type CarouselProps = {
    images?: StashboardMedia[]
    stashboard?: Stashboard;
}

const Carousel = ({ images, stashboard }: CarouselProps) => {


    const {
        slider_counter_background,
        slider_counter,
        slider_dots_background,
    } = useMessagesStyles();
    const [snapIndex, setSnapIndex] = useState(0);
    const [imgHeights, setImgHeights] = useState([]);

    useEffect(() => {

        document.querySelector('.swiper-pagination-bullet-active')?.setAttribute('style', `background-color: ${slider_dots_background} !important`);
    });

    const detailsScreen = window.location.href.includes(stashboard._key);

    return (
        <Swiper
            spaceBetween={0}
            navigation={false}
            pagination={{
                clickable: true,
                type: 'bullets'
            }}
            keyboard={true}
            modules={[Pagination, Mousewheel, Keyboard]}
            className="mySwiper"
            style={
                (detailsScreen && stashboard.type === 'mp5') ?
                    {
                        pointerEvents: 'auto',
                        width: '100%',
                        height: '100vh',
                    }
                    : 
                    {
                        pointerEvents: 'auto',
                        width: '100%',
                        height: imgHeights[snapIndex] ? `${imgHeights[snapIndex]}px !important` : 'auto'
                    }
            }
            onSlideChange={(swiper) => {

                setSnapIndex(swiper.snapIndex);
            }}
            autoHeight={true}
        >
            {images && images.length > 0 && images.map((el, index) => (

                <SwiperSlide
                    style={{
                        width: '100%',
                    }}
                    key={index + imgHeights[index]}
                >
                    <CarouselCard index={index} item={el} stashboard={stashboard} setImgHeight={(height: number) => {

                        setImgHeights((prevHeights) => {
                            const newHeights = [...prevHeights];
                            newHeights[index] = height; 
                            return newHeights;
                        });
                    }} currentIndex={snapIndex}/>
                </SwiperSlide>
            ))}
            {
                images && images.length > 1 && (
                    <Box
                        position={'absolute'}
                        top={-30}
                        right={4}
                        mt={12}
                        px={2}
                        bg={slider_counter_background}
                        alignItems='center'
                        justifyContent={'center'}
                        flexDirection='row'
                        borderRadius={8}
                        zIndex={1}
                    >
                        <Caption
                            color={slider_counter}
                            fontSize={12}
                        >
                            {snapIndex + 1}/{images.length}
                        </Caption>
                    </Box>
                )
            }
        </Swiper>

    );

};

export default Carousel;
